import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';

import createHistory from 'history/createBrowserHistory';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import { Link } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import BackIcon from '@material-ui/icons/ChevronLeft';
import { Redirect } from 'react-router-dom';
import Modal from '@material-ui/core/Modal';
import { NotificationManager} from 'react-notifications';
import firebase from "firebase/app";
import "firebase/firestore";
import _ from 'lodash'
import LessonComp from "../components/LessonComp"
import ButtonBase from '@material-ui/core/ButtonBase';
import * as STATIC from '../config/static';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';

import Advance from './Advance';
import InnerPage from './InnerPage';
import CircularProgress from '@material-ui/core/CircularProgress';
import TopBar from '../components/TopBar';
const days = [0, 1, 2, 3, 4, 5];
const defaultSetting = {
  type: [],

  rows: 3,
  showTime: 6,
  answerTime: 10,
  qCount: 10,
  maxNumber: 10,
  digits: 1,
  digits1: 1,
  digits2: 1,
  displaySetting: 0,
  displayShow: 0,
  lessThan0: 0
}

function searchLabel(array, value) {
  let rel = '';
  let index = array.findIndex(a => a.value == value);
  if (index > -1) {
    rel = array[index].label;
  }
  return rel;
}
let _this;
const DWIDTH = 980;

class Marathon extends Component {
  constructor() {
    super();
    _this = this;
    this.state = { wWidth: 0, wHeight: 0,setting:{}, message: '',loading:true,ranks:[],rankLevel:"all"};
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  handleChange = name => event => {

    event.preventDefault();
    this.setState({
      [name]: event.target.value

    });
  }

  async loadRank() {
    let ACCOUNT = store.getState().ACCOUNT;
    await _this.setState({loading:true});
    //console.log(ACCOUNT.idkhoahoc)
    try {
      let ref = firebase.firestore().collection('Marathon');
      let type = this.state.rankLevel;
      if(type!="all")
      {
        ref = ref.where("type","==",type);
      }
      ref = ref.orderBy("rows","desc").limit(50);
      let data = await ref.get();
      let ranks=[];
      if(data.size>0)
      {
        data.forEach(doc=>{
          ranks.push(doc.data());
        })
      }
      this.setState({ranks});
    }
    catch(e)
    {
      console.log(e);
    }

    await _this.setState({loading:false});

  }

  getStar(result) {

    let curStar = 0;
    let curMin = 100;
    for (let i = 0; i < 7; i++) {
      let newMin = Math.abs(i / 6 * 100 - result);
      console.log(newMin);
      if (newMin < curMin) {
        curStar = i / 2;
        curMin = newMin;
      }
    }
    if (curStar == 3 && result != 100)
      curStar = 2.5;
    return curStar;
  }

  async componentDidMount() {
    //console.log(moment().add(27,"hours").endOf("days").diff(moment().endOf("days"),"days"));
    //console.log('Business',days);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    let checked = await STATIC.checkVersion();
    if(checked!=true)
    {
      //console.log(checked);
      store.dispatch({ type: 'UP_VER', UP_VER: checked });
    }
    this.loadBingo();
    this.loadRank();

  }

  async loadBingo(){
    let sDoc = await firebase.firestore().collection('Marathon').doc("#Setting").get();
    //console.log(sDoc.exists)
    if(sDoc.exists)
    {
      let setting = sDoc.data();
      setting.id = sDoc.id;
      if(moment(setting.endTime).isBefore(moment())||moment(setting.startTime).isAfter(moment()))
      {

        //return;
      }
      _this.setState({setting});

    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }


  getFinishForWeek(t) {
    return 0;
    return 6 - t % 6 == 0 ? 1 : 6 - t % 6;
  }
  getStarForDay(t, size = 30) {
    let array = [];
    for (let i = 1; i <= 3; i++) {
      let item = (<StarIcon key={i} style={{ fontSize: size }} />);
      if (i > t) {
        item = (<StarBorderIcon key={i} style={{ fontSize: size }} />);
      }
      array.push(item);
    }
    return array;
  }
  async onLessonEnd(questions) {
    //console.log(questions);
    let count = 0;
    let countCorrect = 0;
    for (let q of questions) {
      if (q.status) {
        count++;
        if (q.status == 1) {
          countCorrect++;
        }
      }
    }
    let MSetting = _this.state.MSetting;
    let passPercent = MSetting.percent?MSetting.percent:80;

    let percent = Math.round(countCorrect / questions.length * 100);
    let ACCOUNT = store.getState().ACCOUNT;
    let nResult = {id_student:ACCOUNT.id,percent,name:ACCOUNT.ten,mahs:ACCOUNT.mahs,type:MSetting.name,rows:parseInt(MSetting.rows),qCount:questions.length,showTime:MSetting.showTime};
    //console.log(nResult);
    if(percent>=passPercent)
    {
      _this.postResultToServer(nResult);
    }
    _this.setState({ showResult: true,result:{percent,passPercent,countCorrect,qlength: questions.length,questions},nResult });
    return;

    // if(count==countCorrect&&count==questions.length)
    // {
    //   _this.setState({showSignUp:true});
    // }



  }
  async postResultToServer(result){
  //  console.log("post result");
  if(!result)
  {
    _this.setState({saving:false,saving_error:false});
    return;
  }
 await  _this.setState({saving:true,saving_error:false});

    //console.log(JSON.stringify(result));
    //return;
    //let res = await STATIC.postFormData("http://localhost:5000/vnsuperbrain/us-central1/Student_PostResultAdvance2",{result:JSON.stringify(result)});
    let res = await STATIC.postFormData(STATIC.API_STUDENT_MARATHONRESULT,{result:JSON.stringify(result)});
    //console.log(res);
    if(res)
    {
      if(res.status==0)
      {
        await  _this.setState({saving_error:true});

      }
      else {

        let ACCOUNT = store.getState().ACCOUNT;
        //console.log(ACCOUNT.idkhoahoc)

            let aDoc =  await firebase.firestore().collection('data_students').doc('data_students-'+ACCOUNT.id).get();
            let addDay = 0;
            if(aDoc.exists){
              let sACC = aDoc.data();
              sACC.type = 0;
              localStorage.setItem('ACCOUNT', JSON.stringify(sACC));
              store.dispatch({ type: 'ACCOUNT', ACCOUNT:sACC });
              if(sACC.MarathonCDay!=ACCOUNT.MarathonCDay&&sACC.MarathonCDay>(ACCOUNT.MarathonCDay||0))
              {
                console.log("addDay");
                addDay=1;
              }
            }
            await  _this.setState({saving:false,addDay});
      }
    }
    else {
      await  _this.setState({saving_error:true});
    }
  }

  backClick() {

      this.props.history.push('/marathon');

  }
  onCloseModal(e) {
    _this.setState({ showResult: false, curDay: -1 })
  }



changeResult(index)
{
  let {fResults} = _this.state;
  if(index<=fResults.length-1&&index>=0)
  {
    _this.setState({result:fResults[index],rIndex:index});
  }
}

handleChangeDigits = (name,max) => event => {

  let value = event.target.value;
  if(value>max)
  {
    value=max;
  }

  this.setState({
    [name]: value
  });

}
async saveMSetting()
{let ACCOUNT = store.getState().ACCOUNT;
  await STATIC.postFormData(STATIC.API_STUDENT_MARATHON,{id:ACCOUNT.id,MSetting:JSON.stringify(_this.state.MSetting)});
}
selectRankLevel(level)
{
  _this.setState({rankLevel:level},()=>_this.loadRank())
}
  render() {
    const { classes,t } = this.props;
    const { wWidth, wHeight,loading,setting, ranks} = this.state;
    let width = DWIDTH;
    if (wWidth < DWIDTH) {
      width = wWidth;
    }
    let sRate = 980 / 690;;

    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }

    let fBig = width * 0.08;
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let fSmaller = width * 0.015;
    let bRate = 391 / 271;

    let weeks = [];



    let ACCOUNT = store.getState().ACCOUNT;
    if (!ACCOUNT) {

      return (<Redirect to='/login' />);
    }
    let bWidth = width / 2;
    let bWidth2 = width-STATIC.calSize(40, STATIC.DWIDTH, width);
    let MarathonCDay = ACCOUNT.MarathonCDay||0;
    let MarathonTDay = ACCOUNT.MarathonTDay||0;
    let MarathonTotal = 0;

    //console.log(MarathonCDay,MarathonTotal);
    let LANG = store.getState().LANG;



    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>

<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />

              <div style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}><img src={setting.logo_img&&setting.logo_img.length>0?setting.logo_img:""} style={{ width: STATIC.calSize(70, STATIC.DWIDTH, width), height: "auto" }} /></div>
                </div>
                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
              </div>
              <Grid container style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width)}}>
                <Grid xs={12} style={{textAlign:'center',display:'flex',justifyContent:'center'}}>
                  <Grid xs={2} style={{backgroundColor:_this.state.rankLevel=="all"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                    <ButtonBase
                      focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('all')}>
                      <div style={{ color: 'white', fontSize: fTitle,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >{t('common.all')}</div>

                  </ButtonBase>
                  </Grid>
                </Grid>
                <Grid xs={2} style={{backgroundColor:_this.state.rankLevel=="Basic"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('Basic')}>
                    <div style={{ color: 'white', fontSize: fTitle,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >Basic</div>

                </ButtonBase>
                </Grid>
                <Grid xs={2} style={{backgroundColor:_this.state.rankLevel=="LB+"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('LB+')}>
                    <div style={{ color: 'white', fontSize: fTitle,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >LB+</div>

                </ButtonBase>
                </Grid>
                <Grid xs={2} style={{backgroundColor:_this.state.rankLevel=="LB-"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('LB-')}>
                    <div style={{ color: 'white', fontSize: fTitle,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >LB-</div>

                </ButtonBase>
                </Grid>
                <Grid xs={2} style={{backgroundColor:_this.state.rankLevel=="BB+"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('BB+')}>
                    <div style={{ color: 'white', fontSize: fTitle,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >BB+</div>

                </ButtonBase>
                </Grid>
                <Grid xs={2} style={{backgroundColor:_this.state.rankLevel=="BB-"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('BB-')}>
                    <div style={{ color: 'white', fontSize: fTitle,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >BB-</div>

                </ButtonBase>
                </Grid>
                <Grid xs={2} style={{backgroundColor:_this.state.rankLevel=="+/-"?'#8bc53f':'gold',display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <ButtonBase
                    focusRipple style={{width:'100%'}} onClick={()=>this.selectRankLevel('+/-')}>
                    <div style={{ color: 'white', fontSize: fNormal,textAlign:'center',color: 'rgb(5, 63, 34)',marginTop:STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width) }} >+/-</div>

                </ButtonBase>
                </Grid>

              </Grid>
              <div style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),height:STATIC.calSize(750, STATIC.DWIDTH, width),overflow:'auto'}}>
                {ranks?ranks.map((r,index)=>{
                  let macn = r.mahs;
                  let tArr = r.mahs.split("-");
                  if(tArr.length>0)
                  macn = tArr[0];
                  if(r.tencn)
                  macn=r.tencn;
                return (<div
                  key={"r"+index}
                  style={{ width: bWidth2, minHeight: bWidth*0.25,marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), backgroundColor: index<3?'gold':'#8bc53f', display: 'flex',flexDirection:'row' }}>
                    <div style={{borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width),minWidth:bWidth2*0.15,display:'flex',justifyContent:'center',alignItems:'center',backgroundColor:'rgba(0,0,0,0.5)'}}>
                        <div style={{ color: 'white', fontSize: fLarge,textAlign:'center',textTransform:'uppercase' }} >{index+1}</div>
                    </div>
                <div style={{flexGrow:1,paddingLeft:STATIC.calSize(10, STATIC.DWIDTH, width),position:'relative',alignItems:'center'}}>
                  <div style={{ color: 'rgb(5, 63, 34)', fontSize: fTitle,textAlign:'left',width:'100%' }} >{r.name+' - '+r.rows+"R"+(this.state.rankLevel=="all"?("/"+r.type):"")}</div>
                  <div style={{ color: 'rgb(5, 63, 34)', fontSize: fNormal,textAlign:'left',width:'100%' }} >{macn}</div>
                </div>

              </div>)
            }):<div style={{fontSize:fLarge}}>{t('common.no_result')}</div>}
              </div>



              <Link to="/" style={{ width: '100%' }}>
                <img
                  src={setting.logo_img&&setting.logo_img.length>0?setting.logo_img:""}
                  style={{ maxWidth: 296, height: 'auto',  width: STATIC.calSize(140, STATIC.DWIDTH, width) }} />
              </Link>
            </div>
          </div>
        </div>
        <Modal
open={loading}
onClose={() => this.setState({ loading: false })}
aria-labelledby="simple-modal-title"
aria-describedby="simple-modal-description"
>
<div style={{position:'fixed',top:0,left:0,right:0,bottom:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
<div style={{textAlign:'center'}}>
<CircularProgress style={{color:'white'}}/>
</div>
</div>
</Modal>



      </div>
    );
  }
}


Marathon.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Marathon));
